import React from "react";
import { FiShield, FiCpu, FiSearch, FiMessageSquare, FiBookOpen, FiActivity, FiGlobe } from "react-icons/fi";
import "../../styles/AboutSection.css";
import iamarLogo from '../../assets/logo.svg';

export default function PresentationSection({ style }) {
  return (
    <section className="about-sub-section presentation-section" id="presentation" style={style}>
      <div className="section-header-v2">
        <span className="accent-line"></span>
        <h2>PRÉSENTATION DE L'INSTITUT</h2>
      </div>
      
      <div className="presentation-central-identity">
        <div className="brand-focus-box">
          <img src={iamarLogo} alt="IAMAR Logo" className="central-branding-logo" />
        </div>
        
        <div className="mission-statement-box">
          <p className="lead-text">
            L'Institut Afro-Méditerranéen d'Analyse des Risques (<strong>IAMAR</strong>) est une plateforme internationale de recherche, de formation et d'expertise dédiée à l'étude des transformations contemporaines de la gouvernance sécuritaire.
          </p>
          <p className="mission-details">
            Implanté à Agadir, au carrefour des espaces africain, méditerranéen et euro-atlantique, 
            IAMAR se positionne comme un acteur stratégique émergent, capable de produire des analyses à haute valeur ajoutée 
            et de proposer des solutions opérationnelles adaptées aux enjeux complexes de sécurité et de développement.
          </p>
        </div>
      </div>

      <div className="presentation-content">
        <div className="intervention-grid">
          <div className="section-header-v2">
            <span className="accent-line"></span>
            <h3>DOMAINES D'INTERVENTION</h3>
          </div>
          <div className="domain-grid-2x2">
            <div className="domain-card-v2 domain-blue">
              <FiShield className="domain-icon-v2" />
              <div className="domain-info-v2">
                <h4>Gouvernance sécuritaire et réforme des institutions</h4>
              </div>
            </div>
            <div className="domain-card-v2 domain-red">
              <FiCpu className="domain-icon-v2" />
              <div className="domain-info-v2">
                <h4>Transformation numérique et cybersécurité</h4>
              </div>
            </div>
            <div className="domain-card-v2 domain-white">
              <FiSearch className="domain-icon-v2" />
              <div className="domain-info-v2">
                <h4>Analyse des risques et intelligence stratégique</h4>
              </div>
            </div>
            <div className="domain-card-v2 domain-black">
              <FiMessageSquare className="domain-icon-v2" />
              <div className="domain-info-v2">
                <h4>Communication publique et dynamiques sociétales</h4>
              </div>
            </div>
          </div>
        </div>

        <div className="missions-chart-container">
          <div className="section-header-v2">
            <span className="accent-line"></span>
            <h3>MISSIONS PRINCIPALES</h3>
          </div>
          <div className="mission-flow-chart">
            <div className="mission-step">
              <div className="step-number">01</div>
              <div className="step-content">
                <FiSearch className="step-icon" />
                <h4>Recherche Appliquée</h4>
                <p>Produire une recherche scientifique de pointe.</p>
              </div>
            </div>
            <div className="mission-step">
              <div className="step-number">02</div>
              <div className="step-content">
                <FiBookOpen className="step-icon" />
                <h4>Formation</h4>
                <p>Développer des programmes de formation exécutive.</p>
              </div>
            </div>
            <div className="mission-step">
              <div className="step-number">03</div>
              <div className="step-content">
                <FiActivity className="step-icon" />
                <h4>Accompagnement</h4>
                <p>Soutenir les institutions dans leur transformation.</p>
              </div>
            </div>
            <div className="mission-step">
              <div className="step-number">04</div>
              <div className="step-content">
                <FiGlobe className="step-icon" />
                <h4>Dialogue</h4>
                <p>Créer des espaces de dialogue international.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
